import { units } from '@ui/css';
import { makeSizeTokens } from '@utils/react/selectors';

const footerSize = makeSizeTokens("--results-footer", {
  height: units.px(80),
  width: "100%"
});
const footer = "_35sfscsvli";
const retryButton = "_35srxyt1r0";
const shareButton = "_35ssrxmnw8";
const mobileCloseButton = "_35smqgamt2";

export { footer, footerSize, mobileCloseButton, retryButton, shareButton };
import "./molecule.footer.style.linaria.module.css";
//# sourceMappingURL=molecule.footer.style.js.map
